import log from "loglevel";

import { STAGE } from "./constants";

const initLogConfig = (stage: typeof STAGE) => {
  if (stage === "development") {
    log.setDefaultLevel("trace");
  } else {
    log.setDefaultLevel(stage === "production" ? "silent" : "debug");
  }
};

export default initLogConfig;
